export default "__VITE_ASSET__CX6BCCqg__"